import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../Header";
import Footer from "../Footer";
import { fetchArchiveData, fetchAuthArchive, fetchBlogs } from "../../redux/actions/action";
import { useEffect } from "react";

const ViewArchive = ({topicName}) => {
  const archivedBlogs = useSelector((state) => state.uploadBlog.archivedBlogsByTopic)

  const authArchive = useSelector((state) =>state.blogReducer.allAuthImages)
  
       const dispatch = useDispatch()  

useEffect(()=>{
  dispatch(fetchBlogs())
  dispatch(fetchAuthArchive())
},[dispatch])


  if (!archivedBlogs || Object.keys(archivedBlogs).length === 0) {
    return (
      <div className="flex flex-col bg-gray min-h-screen w-full overflow-hidden">
        <div className="fixed top-0 right-0 left-0 h-[80px] z-[50]">
          <Header />
        </div>
        <main className="flex-grow mt-[80px] flex justify-center items-center">
          <p className="text-xl text-white">No archived blogs available.</p>
        </main>
        <Footer />
      </div>
    );
  }
  

  return (
    <div className="flex flex-col bg-gray min-h-screen w-full overflow-hidden">
      <div className="relative top-0 right-0 left-0 h-[80px] z-[50]">
        <Header />
      </div>

      <main className="flex-grow pt-40 px-6 md:px-20">
        <h1 className="text-3xl font-bold mb-10 text-white">Archived Blogs</h1>

        {
        Object.entries(archivedBlogs || {}).map(([topic, blogs]) => {
                    // const sortedBlogs = [...blogs].sort((a, b) => b.id - a.id);
                    // const olderBlogs = sortedBlogs.slice(0,5)
return(
          <div key={topic} className="mb-6">
            <h2 className="text-xl font-semibold text-white mb-2">{topic}</h2>
          

             {blogs.length > 0? (
                    blogs.map((blog) => {

              
                  // Match blog.id with blog_id in authArchive
        const authorInfo = authArchive.find(
          (auth) => auth.blog_id === blog.id
        ); 
            
             return (
          <div key={blog.id} className="bg-white p-4 rounded shadow mb-4">
            <p className="text-gray-800 font-medium mb-2">
              {blog.description}
            </p>

             {authorInfo && (
              <div className="flex flex-col items-start mt-4">
                <img
                  src={authorInfo.image_url}
                  alt={authorInfo.authorName}
                  className="w-12 h-12 rounded-full object-cover"
                />
                
                <span className="text-gray-700 font-semibold">
                  {authorInfo.authorName}
                </span>
                
              </div>
            )}
          </div>
        );
      })
      
    ) : (
      <p className="text-white">No archived blogs in this topic</p>
    )}
  </div>
);
})}

 
      </main>

      <Footer />
    </div>
  );



};

export default ViewArchive;
